import React, { useEffect } from 'react';
import { FormFieldProps } from '../../FormTypes';
import { Grid } from '@material-ui/core';
import moment from 'moment';
import { useWidth } from 'reusableComponents/useWidth';
import JobDatePicker from './JobDatePicker';
import { Text } from 'library';
import { isBefore } from 'date-fns';

interface JobDateRangePickerProps {
    startDate: FormFieldProps<moment.Moment | null>;
    endDate: FormFieldProps<moment.Moment | null>;
}

export default function BusinessJobDateRangePicker({ startDate, endDate }: JobDateRangePickerProps) {
    const width = useWidth();
    const { setValid } = startDate;

    useEffect(() => {
        const valid = startDate.value !== null && endDate.value !== null && startDate.value <= endDate.value;
        setValid(valid);
        if (isBefore(endDate.value?.toDate() ?? new Date(), startDate.value?.toDate() ?? new Date())) {
            endDate.setValue(startDate.value);
        }
    }, [startDate]);

    return (
        <Grid container>
            <Grid item style={{ marginRight: width === 'xs' ? 0 : 30, width: width === 'xs' ? '100%' : undefined }}>
                <Text variant="caption">Start Date</Text>
                <JobDatePicker
                    jobDate={startDate}
                    additionalErrorState={(startDate.value as moment.Moment) < (endDate.value as moment.Moment)}
                    maxDate={moment().add(3, 'months')}
                    id="start-date"
                />
            </Grid>
            <Grid item style={{ width: width === 'xs' ? '100%' : undefined }}>
                <Text variant="caption">End Date</Text>
                <JobDatePicker
                    jobDate={endDate}
                    minDate={startDate.value || moment()}
                    maxDate={moment(startDate.value).add(3, 'months')}
                    id="end-date"
                />
            </Grid>
        </Grid>
    );
}
